import { useEffect, useState } from "react";
import { MobileIcon, Nav, NavbarContainer, NavIcon, NavItem, NavItemBtn, NavLinks, NavLogo, NavMenu, } from "./Navbar.elements";
import { FaTimes, FaBars } from "react-icons/fa";
import { IconContext } from "react-icons";
import { Button } from "../GlobalStyle";
import LoginDialog from "../dialog_login/LoginDialog";
import ChangePasswordDialog from "../dialog_login/ChangePasswordDialog"
import { useAuth } from "../../context/AdminContext";

function Navbar() {
  //modal iniciar secion
  const { isLoged, logout, tokenRefresh } = useAuth();
  const [modal, setModal] = useState(false);
  const [modalRest, setModalReset] = useState(false);
  const [mobileState, setMobileState] = useState(false);
  const [loginButton, setLoginButton] = useState(false);

  function toggleModal() {
    setModal(!modal);
  }

  function toggleModalReset() {
    setModalReset((prev) => (prev ? false : true));
  }

  const showButton = () => {
    if (window.innerWidth <= 960) {
      setLoginButton(false);
    } else {
      setLoginButton(true);
    }
  };


  window.addEventListener("resize", showButton);

  const handleMenu = () => setMobileState(!mobileState);
  const handleClick = () => setMobileState(!mobileState);


  useEffect(() => {
    const refreshToken = localStorage.getItem('refreshToken');
    if (refreshToken) {
      tokenRefresh();
    }

  }, []);

  useEffect(() => {
    showButton();
  }, []);

  return (
    <>
      {
        window.location.href.includes('politicas') ?
          null :
          <Nav>
            <LoginDialog
              modal={modal}
              toggleModal={toggleModal}
              toggleModalReset={toggleModalReset}

            />
            <ChangePasswordDialog
              toggleModal={toggleModalReset}
              modal={modalRest}

            />
            <NavbarContainer>
              <IconContext.Provider value={{ color: "#fff" }}>
                <NavLogo to="/">
                  Sistema de Gestion
                  <NavIcon />
                </NavLogo>
                <MobileIcon onClick={handleMenu}>
                  {mobileState ? <FaTimes /> : <FaBars />}
                </MobileIcon>
              </IconContext.Provider>
              <NavMenu onClick={handleClick} mobileState={mobileState}>
                {isLoged ?
                  <>
                    <NavItem>
                      <NavLinks to="/usuarios">USUARIOS</NavLinks>
                    </NavItem>
                    <NavItem>
                      <NavLinks to="/productos">PRODUCTOS</NavLinks>
                    </NavItem>
                    <NavItem>
                      <NavLinks to="/cuentas">CUENTAS CORRIENTES</NavLinks>
                    </NavItem>
                    <NavItem>
                      <NavLinks to="/reportes">REPORTES</NavLinks>
                    </NavItem>
                    <NavItem>
                      <NavLinks to="/pedidos">
                        PEDIDOS
                      </NavLinks>
                    </NavItem>
                  </> : null
                }
                <NavItemBtn>
                  {loginButton ? (!isLoged ? (
                    <Button primary onClick={toggleModal}>Ingresar</Button>

                  ) :
                    (
                      <Button primary onClick={() => { logout() }}>Cerrar sesión</Button>
                    )
                  ) : (
                    <Button fontBig primary onClick={toggleModal}>
                      Ingresar
                    </Button>
                  )}
                </NavItemBtn>
              </NavMenu>
            </NavbarContainer>
          </Nav>}
    </>
  );
}

export default Navbar;
